import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { LPLActivateModalModule } from 'AccountsApp/ts/apps/account-integrations-app/components/account-integrations-page/integrations-items/lpl-integration-activate-modal/lpl-integration-activate-modal.module';
import { ConfigModule } from 'Angular/config/config.module';
import { SimpleDropdownModule } from 'Angular/features/components/dropdowns/simple-dropdown/simple-dropdown.module';
import { SingleSelectDropdownModule } from 'Angular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { MultilineFileUploadModule } from 'Angular/features/components/file-upload/multiline-file-upload/multiline-file-upload.module';
import { LoadingSymbolModule } from 'Angular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ConfirmModalModule } from 'Angular/features/components/modals/confirm-modal/confirm-modal.module';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import { NavigationModule } from 'Angular/features/components/navigation/navigation.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { ImageModule } from 'Angular/features/directives/image/image.module';
import { RedtailCredentialsModalModule } from 'IntegrationsApp/ts/features/redtail-credentials-modal/redtail-credentials-modal.module';
import { AccountIntegrationsPageComponent } from './components/account-integrations-page/account-integrations-page.component';
import { AccountSettingsNavigationComponent } from 'AccountsApp/ts/features/navigation/account-settings-navigation.component';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'Angular/features/components/side-menu/side-menu.component';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class AccountIntegrationsModule {
}
AccountIntegrationsModule.ɵfac = function AccountIntegrationsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AccountIntegrationsModule)(); };
AccountIntegrationsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AccountIntegrationsModule, bootstrap: [AccountIntegrationsPageComponent,
        AccountSettingsNavigationComponent,
        TopBarNavComponent,
        SideMenuComponent] });
AccountIntegrationsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        ConfigModule,
        ConfirmModalModule,
        IconModule,
        FormsModule,
        ImageModule,
        LoadingSymbolModule,
        ModalBaseModule,
        NavigationModule,
        SimpleDropdownModule,
        StoreModule.forRoot({}),
        DisabledModule,
        SingleSelectDropdownModule,
        MultilineFileUploadModule,
        LPLActivateModalModule,
        RedtailCredentialsModalModule] });
